import { useEffect, useRef } from "react";

export default function PerformanceCardModal({ stats, history, user, onClose }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const c = canvasRef.current; if (!c) return;
    const ctx = c.getContext("2d");
    const W = c.width = 1200, H = c.height = 630;
    // bg gradient
    const g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, "#0b0e14"); g.addColorStop(1, "#1a1230");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    // grid
    ctx.strokeStyle = "rgba(255,255,255,0.04)";
    for (let x = 0; x < W; x += 40) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
    for (let y = 0; y < H; y += 40) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }
    // header
    ctx.fillStyle = "#3b82f6"; ctx.font = "bold 22px ui-monospace, monospace"; ctx.fillText("ICT SANDBOX", 60, 80);
    ctx.fillStyle = "#94a3b8"; ctx.font = "16px ui-monospace, monospace"; ctx.fillText(`Trader: ${user?.name || "Anon"}`, 60, 110);
    ctx.font = "12px ui-monospace, monospace"; ctx.fillStyle = "#64748b";
    ctx.fillText(new Date().toUTCString(), 60, 130);

    // big stats
    ctx.font = "bold 96px ui-monospace, monospace";
    ctx.fillStyle = stats.total_pnl >= 0 ? "#10b981" : "#f43f5e";
    ctx.fillText(`${stats.total_pnl >= 0 ? "+" : "-"}$${Math.abs(stats.total_pnl).toFixed(2)}`, 60, 250);
    ctx.fillStyle = "#94a3b8"; ctx.font = "16px ui-monospace, monospace"; ctx.fillText("Total PnL", 60, 280);

    // grid stats
    const items = [
      { label: "Win Rate", value: `${stats.win_rate.toFixed(0)}%`, color: "#eab308" },
      { label: "Trades", value: `${stats.total_trades}`, color: "#94a3b8" },
      { label: "Balance", value: `$${stats.balance.toFixed(0)}`, color: "#10b981" },
      { label: "Avg Win", value: `$${(stats.avg_win || 0).toFixed(0)}`, color: "#10b981" },
      { label: "Avg Loss", value: `$${(stats.avg_loss || 0).toFixed(0)}`, color: "#f43f5e" },
      { label: "Best Trade", value: history.length ? `$${Math.max(...history.map(t=>t.pnl)).toFixed(0)}` : "$0", color: "#a855f7" },
    ];
    const colW = (W - 120) / 3;
    items.forEach((it, idx) => {
      const x = 60 + (idx % 3) * colW, y = 350 + Math.floor(idx / 3) * 130;
      ctx.fillStyle = "rgba(15,23,42,0.6)"; ctx.fillRect(x, y, colW - 20, 110);
      ctx.strokeStyle = "rgba(148,163,184,0.15)"; ctx.strokeRect(x, y, colW - 20, 110);
      ctx.fillStyle = "#64748b"; ctx.font = "12px ui-monospace, monospace"; ctx.fillText(it.label.toUpperCase(), x + 16, y + 30);
      ctx.fillStyle = it.color; ctx.font = "bold 36px ui-monospace, monospace"; ctx.fillText(it.value, x + 16, y + 80);
    });

    // ICT concept tags from analyses
    const concepts = {};
    history.forEach(t => { if (t.analysis?.key_concept_used) concepts[t.analysis.key_concept_used] = (concepts[t.analysis.key_concept_used] || 0) + 1; });
    const topConcept = Object.entries(concepts).sort((a,b) => b[1] - a[1])[0]?.[0];
    if (topConcept) {
      ctx.fillStyle = "#a855f7"; ctx.font = "12px ui-monospace, monospace";
      ctx.fillText(`Top ICT Concept: ${topConcept}`, 60, H - 40);
    }
    ctx.fillStyle = "#475569"; ctx.font = "11px ui-monospace, monospace"; ctx.textAlign = "right";
    ctx.fillText("Powered by Claude Sonnet 4.5 · Real futures data via Yahoo", W - 60, H - 40);
    ctx.textAlign = "left";
  }, [stats, history, user]);

  function download() {
    const c = canvasRef.current; if (!c) return;
    const url = c.toDataURL("image/png");
    const a = document.createElement("a"); a.href = url; a.download = `ict-performance-${Date.now()}.png`; a.click();
  }

  return (
    <div data-testid="perfcard-modal" className="fixed inset-0 bg-black/85 backdrop-blur-md z-50 flex items-center justify-center p-4">
      <div className="bg-[#151a24] border border-slate-800 rounded-2xl max-w-4xl w-full p-6 shadow-2xl">
        <div className="flex justify-between items-start mb-3 border-b border-slate-800 pb-3">
          <h2 className="text-lg font-bold text-white flex items-center gap-2 font-mono">
            <i className="fa-solid fa-id-card text-blue-400"/> Performance Card
          </h2>
          <button data-testid="perfcard-close" onClick={onClose} className="text-slate-500 hover:text-white"><i className="fa-solid fa-xmark text-xl"/></button>
        </div>
        <canvas ref={canvasRef} className="w-full rounded-lg border border-slate-800"/>
        <div className="mt-3 flex gap-2">
          <button data-testid="perfcard-download" onClick={download}
            className="flex-1 py-2.5 bg-blue-600 hover:bg-blue-700 rounded-xl font-bold text-white text-sm">
            <i className="fa-solid fa-download mr-1.5"/> Download PNG
          </button>
        </div>
      </div>
    </div>
  );
}
